import React, { useEffect, useState } from 'react';
import styles from './search-bar.module.css';
import { useFetchUsers } from '../../../actions';
import { useTranslation } from 'react-i18next';

type SearchBarProps = {
  setCurrentPage: (page: number) => void;
};

export const SearchBar: React.FC<SearchBarProps> = ({ setCurrentPage }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const fetchUsers = useFetchUsers(query);

  const handleSearch = () => {
    if (query.trim() !== undefined && query.trim() !== '') {
      localStorage.setItem('search', query);
    } else {
      localStorage.removeItem('search');
    }
    setCurrentPage(1);
    fetchUsers();
  };

  useEffect(() => {
    localStorage.removeItem('search');
  }, []);
  return (
    <div className={styles.searchBar}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={t('search')}
        className={styles.searchInput}
      />
      <button
        onClick={handleSearch}
        className={styles.searchButton}
      >
        <i className="fas fa-search"></i>
      </button>
    </div>
  );
};
